export const relaxMassages = [
   {
      label: 'relaxed_massage',
      value: 'RELAXED_MASSAGE',
   },
   {
      label: 'classical_massage',
      value: 'CLASSIC_MASSAGE',
   },
   {
      label: 'sports_massage',
      value: 'SPORT_MASSAGE',
   },
   {
      label: 'thai_massage',
      value: 'THAI_MASSAGE',
   },
   {
      label: 'hot_stone_massage',
      value: 'HOT_STONES_MASSAGE',
   },
   {
      label: 'chocolate_massage',
      value: 'CHOCOLATE_MASSAGE',
   },
   {
      label: 'honey_massage',
      value: 'HONEY_MASSAGE',
   },
   {
      label: 'candle_massage',
      value: 'CANDLE_MASSAGE',
   },
   {
      label: 'chinese_cupping_massage',
      value: 'CHINESE_BUBBLE_MASSAGE',
   },
   {
      label: 'anti_cellulite_massage',
      value: 'ANTI_CELLULITE_MASSAGE',
   },
   {
      label: 'hawaiian_massage',
      value: 'HAWAIIAN_MASSAGE',
   },
   { label: 'aromatherapy', value: 'AROMATHERAPY' },
   { label: 'kobido_massage', value: 'KOBIDO_MASSAGE' },
   { label: 'facial_and_cleavage_treatments', value: 'FACIAL_AND_CLEAVAGE_TREATMENTS' },
   { label: 'other_massages_and_treatments', value: 'OTHER_MASSAGES_AND_TREATMENTS' },
];

export const sensualMassages = [
   {
      label: 'relaxed_massage',
      value: 'RELAXED_MASSAGE',
   },
   {
      label: 'classical_massage',
      value: 'CLASSIC_MASSAGE',
   },
   {
      label: 'nuru_massage',
      value: 'NURU_MASSAGE',
   },
   {
      label: 'tantra_massage',
      value: 'TANTRA_MASSAGE',
   },
   {
      label: 'body_to_body_massage',
      value: 'BODY_TO_BODY_MASSAGE',
   },
   {
      label: 'hawaiian_massage',
      value: 'HAWAIIAN_MASSAGE',
   },
   {
      label: 'ASMR',
      value: 'ASMR_MASSAGE',
   },
   { label: 'other_sensual_massages', value: 'OTHER_SENSUAL_MASSAGES' },
];
export const physiotherapyMassages = [
   {
      label: 'relaxed_massage',
      value: 'RELAXED_MASSAGE',
   },
   {
      label: 'classical_massage',
      value: 'CLASSIC_MASSAGE',
   },
   {
      label: 'sports_massage',
      value: 'SPORT_MASSAGE',
   },
   {
      label: 'physiotherapy_consultations',
      value: 'PHYSIOTHERAPEUTIC_CONSULTATIONS',
   },
   {
      label: 'therapeutic_massage',
      value: 'MEDICAL_MASSAGE',
   },
   {
      label: 'chinese_cupping_massage',
      value: 'CHINESE_BUBBLE_MASSAGE',
   },
   {
      label: 'rehabilitation',
      value: 'REHABILITATION',
   },
   {
      label: 'kinesiotaping',
      value: 'KINESIOTAPING',
   },
   { label: 'urogynecological_treatments', value: 'UROGYNECOLOGICAL_TREATMENTS' },
   { label: 'dental_physiotherapy', value: 'DENTAL_PHYSIOTHERAPY' },
   { label: 'other_treatments', value: 'OTHER_TREATMENTS' },
];

const relaxSubMassages = [
   'RELAXED_MASSAGE',
   'CLASSIC_MASSAGE',
   'SPORT_MASSAGE',
   'THAI_MASSAGE',
   'HOT_STONES_MASSAGE',
   'CHOCOLATE_MASSAGE',
   'HONEY_MASSAGE',
   'CANDLE_MASSAGE',
   'CHINESE_BUBBLE_MASSAGE',
   'ANTI_CELLULITE_MASSAGE',
   'HAWAIIAN_MASSAGE',
   'AROMATHERAPY',
   'KOBIDO_MASSAGE',
   'FACIAL_AND_CLEAVAGE_TREATMENTS',
   'OTHER_MASSAGES_AND_TREATMENTS',
];

const sensualSubMassages = [
   'RELAXED_MASSAGE',
   'CLASSIC_MASSAGE',
   'NURU_MASSAGE',
   'TANTRA_MASSAGE',
   'BODY_TO_BODY_MASSAGE',
   'HAWAIIAN_MASSAGE',
   'ASMR_MASSAGE',
   'OTHER_SENSUAL_MASSAGES',
];

const physiotherapySubMassages = [
   'RELAXED_MASSAGE',
   'CLASSIC_MASSAGE',
   'SPORT_MASSAGE',
   'PHYSIOTHERAPEUTIC_CONSULTATIONS',
   'MEDICAL_MASSAGE',
   'CHINESE_BUBBLE_MASSAGE',
   'REHABILITATION',
   'KINESIOTAPING',
   'UROGYNECOLOGICAL_TREATMENTS',
   'DENTAL_PHYSIOTHERAPY',
   'OTHER_TREATMENTS',
];

export const massageSubcategories: { [key: string]: string[] } = {
   RELAXED_MASSAGE: relaxSubMassages,
   SENSUAL_MASSAGE: sensualSubMassages,
   PHYSIOTHERAPY: physiotherapySubMassages,
};
